import angular from 'angular';
import 'ui-select';
import 'angular-bootstrap';
import './userIntegrationsServices';

const userIntegrationsControllers = angular.module('applicationModule.userIntegrationsControllers', [
    'applicationModule.userIntegrationsServices',
    'ui.bootstrap',
    'ui.select'
]);

userIntegrationsControllers.controller('UserIntegrationController', ['$scope', '$rootScope', '$stateParams', '$state', 'NgTableParams', 'Integrations', 'AppsoupAPI', 'Permissions', function ($scope, $rootScope, $stateParams, $state, NgTableParams, Integrations, AppsoupAPI, Permissions) {
    'use strict';
    $rootScope.$broadcast('newApp', {select: $stateParams.application_id});
    $scope.writeAccess = Permissions.hasWriteAccess('integrations');

    $scope.application_id = $stateParams.application_id;

    $scope.tableParamsQueue = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoadingQueue = true;
            return Integrations.getListQueue($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);
                    return response.data;
                })
                .finally(function () {
                    $scope.isLoadingQueue = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

    $scope.tableParams = new NgTableParams(AppsoupAPI.getDefaultTableParams(), {
        getData: function (params) {
            $scope.isLoading = true;
            return Integrations.getList($scope.application_id, params._params)
                .then(function (response) {
                    params.total(response.total);
                    params.count(response.per_page);
                    params.page(response.current_page);
                    return response.data;
                })
                .finally(function () {
                    $scope.isLoading = false;
                });
        },
        counts: AppsoupAPI.getDefaultCounts()
    });

}]);

export default userIntegrationsControllers;
